export const BASE_API_URL = process.env.REACT_APP_API; //"https://api.on-bible.com";

export const AUTH_REGISTER = "/auth/register";
export const AUTH_LOGIN = "/auth/login";
